import { render, staticRenderFns } from "./BindGetKnow.vue?vue&type=template&id=d30cbd9e&scoped=true&"
import script from "./BindGetKnow.vue?vue&type=script&lang=js&"
export * from "./BindGetKnow.vue?vue&type=script&lang=js&"
import style0 from "./BindGetKnow.vue?vue&type=style&index=0&id=d30cbd9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30cbd9e",
  null
  
)

export default component.exports